// Misc
import React, { Component, Fragment, createElement } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

// Selectors
import { connectGetters } from 'react-redux-getters'
import { getMe } from 'selectors/me'

// Atoms
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Hidden from '@material-ui/core/Hidden'
import Menu from 'atoms/Menu'
import Avatar from 'atoms/Avatar'
import { LinkMenuItem } from 'atoms/Link'

// Icons
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

// Styles
const styles = theme => ({
  button: {
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      marginRight: -theme.spacing.unit * 2
    }
  },
  label: {
    overflow: 'hidden',
  },
  name: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  expandMoreIcon: {
    marginLeft: theme.spacing.unit,
    color: theme.palette.text.secondary,
  },
  avatar: {
    marginRight: theme.spacing.unit,
  },
})

const mapGettersToProps = state => ({
  meGetter: getMe(state)
})

export default
@connectGetters(mapGettersToProps)
@withStyles(styles)
class UserMenu extends Component {
  static propTypes = {
    meGetter: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    links: PropTypes.array.isRequired,
  }

  state = {
    anchorEl: undefined,
    open: false
  }

  handleButtonClick = (ev) => {
    this.setState({
      open: true,
      anchorEl: ev.currentTarget
    })
  }

  handleMenuClose = () => {
    this.setState({ open: false })
  }

  render() {
    const { meGetter, classes, links } = this.props
    const { open, anchorEl } = this.state
    const { manager } = meGetter.data
    const { firstName, lastName, image } = manager || meGetter.data
    return (
      <Fragment>
        <Menu
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          getContentAnchorEl={undefined}
          onClose={this.handleMenuClose}
        >
          { links.map(({ icon, label, to, external }) => (
            <LinkMenuItem key={to} to={to} external={!!external} onClick={this.handleMenuClose}>
              <ListItemIcon>{ createElement(icon) }</ListItemIcon>
              <Typography>{ label }</Typography>
            </LinkMenuItem>
          )) }
          <LinkMenuItem to="/actions/logout">
            <ListItemIcon><PowerSettingsNewIcon /></ListItemIcon>
            <Typography>Log out</Typography>
          </LinkMenuItem>
        </Menu>
        <Button
          size="small"
          onClick={this.handleButtonClick}
          className={classes.button}
          classes={{ label: classes.label }}
        >
          <Hidden xsDown>
            <Avatar
              size="small"
              image={image}
              firstName={firstName}
              lastName={lastName}
              className={classes.avatar}
            />
          </Hidden>
          <div className={classes.name}>
            { firstName }
            {' '}
            { lastName }
          </div>
          <ExpandMoreIcon className={classes.expandMoreIcon} />
        </Button>
      </Fragment>
    )
  }
}
